import {MatPaginatorIntl} from "@angular/material/paginator";

export function getCustomPaginatorConfig(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Sayfa başına kayıt:';
  paginatorIntl.nextPageLabel = 'Sonraki sayfa';
  paginatorIntl.previousPageLabel = 'Önceki sayfa';
  paginatorIntl.firstPageLabel = 'İlk sayfa';
  paginatorIntl.lastPageLabel = 'Son sayfa';


  paginatorIntl.getRangeLabel = function (page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} / ${length}`;
  };

  return paginatorIntl;
}
